import { selector } from './selector';
import * as events from "./events";

const PageFrontPage = (function ($) {

    function initEvents() {
        $(document).on('click', selector.btnCheckSerialNumber, events.checkTag);
        $(document).on('click', selector.reloadCaptcha, events.reloadCaptcha);
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export { PageFrontPage };